import Cookies from 'js-cookie';
import { LOGIN_HOST } from '../const';

const TOKEN_KEY = 'cdb_uid';
const location = window.location;
const CBD_KEYS = [
  'cdb_uid',
  'cdb_sTime',
  'cdb_union_user',
  'cdb_last_login_time',
  'cdb_uid_unique_token',
  'cdb_msokey'
];

/**
 * 登录的默认处理策略
 */

export default {
  name: 'default',
  // 判断登录态
  isLogin: () => {
    return !!Cookies.get(TOKEN_KEY);
  },
  // 去登录
  gotoLogin: () => {
    const {
      pathname, search, protocol, host
    } = location;
    const baseUrl = `${protocol}//${LOGIN_HOST}/account/login.php?`;
    const params = {
      goback: 1
    };

    const loginUrl = `${baseUrl
            + Object.keys(params)
              .map((key) => {
                return `${key}=${params[key]}`;
              })
              .join('&')
    }&ref=`;

    // 不直接用location.href是因为详情页会自动加上#/，那样登录回来就会打不开
    const refUrl = `${protocol}//${host}${pathname}${search}`;

    window.location.href = `${loginUrl}${encodeURIComponent(refUrl)}`;
  },
  // 清除登录状态
  clearLogin: () => {
    const domain = window.location.host
      .replace(/^[a-z-]+/i, '')
      .replace(/:\d+/, '');
    CBD_KEYS.forEach((key) => {
      Cookies.remove(key, { domain });
    });
  }
};
